import * as i18n from 'i18n-js';
import en from '../locales/en';

(Object as any).assign(i18n, { translations: { en }, locale: 'en' });

export default i18n.t.bind(i18n);

export const DATE_LOCALE = 'en-US';



// WEBPACK FOOTER //
// ./src/utils/i18n.ts